// extracted by mini-css-extract-plugin
module.exports = {"bottomBarLogoHeight":"22"};